module.exports = __webpack_public_path__ + "img/news-010.24f41bd3.jpg";